import React, { useEffect, useState } from 'react';
import './_styles.write-off.scss';
import Dropdown from '../../components/Dropdown/Dropdown';
import { createIssue, createWriteOff, getParties, getSites } from '../../api';
import ProductTable from '../../components/ProductTable/ProductTable';
import InputField from '../../components/InputField/InputField';
import Button from '../../components/Button/Button';
import ProductsModal from '../../components/ProductsModal/ProductsModal';

const WriteOff = () => {
  const [sites, setSites] = useState([]);
  const [reason, setReason] = useState('');
  const [parties, setParties] = useState([]);
  const [selectedSite, setSelectedSite] = useState(0);
  const [selectedParty, setSelectedParty] = useState(0);

  useEffect(() => {
    getParties(null, true, true).then(({ data }) => {
      setParties(
        data.map((site) => {
          return {
            key: site.name,
            value: site.id
          };
        })
      );
    });
  }, []);

  const selectParty = (e) => {
    setSelectedParty(e.target.value);
    getSites(e.target.value).then(({ data }) => {
      setSites(
        data.map((site) => {
          return {
            key: site.name,
            value: site.id
          };
        })
      );
    });
  };

  const selectSite = (e) => {
    setSelectedSite(e.target.value);
  };

  const submitWriteOff = async (products, callback) => {
    const requestData = {
      party: selectedParty,
      site: selectedSite,
      reason: reason,
      products
    };

    const { data } = await createWriteOff(requestData);

    if (data) {
      alert(data.message);
      callback(data.success);
    } else {
      callback(false);
    }
  };

  return (
    <>
      <div className='screen'>
        <div className='dropdowns'>
          <Dropdown
            placeholder='Select a party'
            icon='user'
            options={parties}
            onChange={selectParty}
          />
          {selectedParty != 0 && (
            <Dropdown
              placeholder='Select a site'
              icon='pin'
              options={sites}
              onChange={selectSite}
            />
          )}
          <InputField
            placeholder='Reason'
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>
        <ProductTable
          canAddProduct={selectedSite != 0}
          party={selectedParty}
          site={selectedSite}
          onDone={submitWriteOff}
          canLoadProducts
          canSubmit={!!reason}
        />
      </div>
    </>
  );
};

export default WriteOff;
